const React = require('react')
const { useNetworkConfig } = require('@contexts')
const { useFormatNumber } = require('@hooks')
const { LoadingSpinner } = require('@components/loading')
const { Cube, Timer, CalendarDots } = require('@phosphor-icons/react')

require('@styles/pages/block/countdown/table.countdown.css')

const TableCountdownBlockTime = props => {
    const { loading, item } = props

    const { network } = useNetworkConfig()
    const formatNumber = useFormatNumber()

    const timeUnits = [
        { label: 'Days', key: 'days' },
        { label: 'Hours', key: 'hours' },
        { label: 'Mins', key: 'minutes' },
        { label: 'Secs', key: 'seconds' }
    ]

    return (
        <>
            <div className='countdown-table-title'>
                <Timer className='countdown-table-icon' weight='regular' size={24} />
                Countdown
            </div>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '86px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <div className='countdown-grid'>
                    {timeUnits.map(unit => (
                        <div key={unit.key} className='countdown-item'>
                            <div className='countdown-label'>{unit.label}</div>
                            <div className={`countdown-value ${network.name}-text-color`}>
                                {formatNumber(item.displayTime[unit.key])}
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <div className='table-divider' />
            <div className='countdown-table-title'>
                <CalendarDots className='countdown-table-icon' weight='duotone' size={24} />
                Estimated Target Date
            </div>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '120px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <div className={`countdown-target-time ${network.name}-text-color`}>
                    {item.targetBlockTimestamp &&
                        new Date(item.targetBlockTimestamp * 1000).toUTCString().replace('GMT', 'UTC')}
                </div>
            )}
        </>
    )
}

const TableCountdownBlockInfo = props => {
    const { loading, item } = props

    const { network } = useNetworkConfig()

    const blockDetails = [
        { label: 'Countdown For Block', key: 'blockNumber', hasColor: true },
        { label: 'Remaining Blocks', key: 'blocksUntilTarget', hasColor: false },
        { label: 'Current Block', key: 'currentBlockNumber', hasColor: false }
    ]

    return (
        <>
            <div className='countdown-table-title'>
                <Cube className='countdown-table-icon' weight='regular' size={24} />
                Block Details
            </div>
            {loading ? (
                <>
                    <div className='d-flex justify-content-center align-items-center' style={{ height: '266px' }}>
                        <LoadingSpinner />
                    </div>
                </>
            ) : (
                <div className='block-details-grid'>
                    {blockDetails.map(detail => (
                        <div key={detail.key} className='block-detail-item'>
                            <div className='countdown-label'>{detail.label}</div>
                            <div
                                className={`block-detail-value ${detail.hasColor ? `${network.name}-text-color` : ''}`}
                            >
                                #{item[detail.key]}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}

module.exports = { TableCountdownBlockTime, TableCountdownBlockInfo }
